module.exports = __webpack_public_path__ + "static/media/ai.80d82fb2.svg";